import React, { useMemo } from 'react';
import DSBox from '../../../../design-system/DSBox';
import { useTheme } from '@mui/material';
import { ProductMockTemplate } from '../../../../api/productMockTemplates';
import { getScaledCloudinaryUrl } from '../../../../utils';

type MockupSelectCardProps = {
  mockup: ProductMockTemplate;
  isSelected: boolean;
  onToggle: () => void;
};

const MockupSelectCard = ({
  mockup,
  isSelected,
  onToggle,
}: MockupSelectCardProps) => {
  const { spacing, palette } = useTheme();

  const scaledPreviewUrl = useMemo(
    () => getScaledCloudinaryUrl(mockup.previewImageUrl, 400),
    [mockup.previewImageUrl],
  );

  return (
    <DSBox
      onClick={onToggle}
      sx={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: spacing(1),
        border: `3px solid ${isSelected ? palette.primary.main : 'transparent'}`,
        overflow: 'hidden',
        transition: 'all 0.2s ease',
        maxWidth: '340px',
        flexShrink: 0,
        '&:hover': {
          borderColor: isSelected
            ? palette.primary.main
            : palette.action.selected,
        },
      }}
    >
      <img
        src={scaledPreviewUrl}
        alt={mockup.fileName}
        style={{
          width: '100%',
          maxWidth: '340px',
          maxHeight: '340px',
          aspectRatio: '1/1',
          objectFit: 'cover',
        }}
      />
    </DSBox>
  );
};

export default MockupSelectCard;
